// extracted by mini-css-extract-plugin
module.exports = {"wrap":"marquee_wrap_VszCT","content":"marquee_content_3WhQO","text":"marquee_text_2AERD","animation":"marquee_animation_xxKH_","paused":"marquee_paused_xAkYt"};